import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import { TypeAsserter, TypeChecker } from '@attain-apps/type-guards'
import gql from 'graphql-tag'

import * as models from '../../models'

export const DOC = gql`
  query QueryOutcomesData($tenantId: ID!, $zoneId: ID!, $query: AWSJSON!) {
    tenant(id: $tenantId) {
      zone(id: $zoneId) {
        data(query: $query)
      }
    }
  }
`

const TRANSFORMER = graphql.transformers.OUT.default(
  graphql.transformers.OUT.select<
    graphql.schema.QueryRecordsDataQuery,
    readonly models.Outcome[],
    'tenant'
  >(
    'tenant',
    graphql.transformers.OUT.select(
      'zone',
      graphql.transformers.OUT.select(
        'data',
        graphql.transformers.OUT.pipe(
          graphql.transformers.OUT.json(),
          // REVIEW: how to leverage transformers to achieve static type checking?
          graphql.transformers.OUT.custom(originalRecords =>
            TypeAsserter.validateButJustWarn(
              originalRecords,
              // adding custom type asserter to ensure the type is an array of Record
              TypeAsserter.Factory.from(
                TypeChecker.Factory.list(models.Outcome.isOutcome),
                // this will throw a custom error if the type is not correct
                {
                  customError: (tg, value) =>
                    new TypeAsserter.AssertionError({
                      typeDescription: 'display.summit.allocations.Outcome[]',
                      value,
                    }),
                },
              ),
            ),
          ),
        ),
      ),
    ),
  ),
  [],
)

export const execute = graphql.createExecutor<
  graphql.schema.QueryDataQuery,
  readonly models.Outcome[],
  graphql.schema.QueryRecordsDataQueryVariables
>({
  query: DOC,
  transformer: TRANSFORMER,
})
